import { Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material";
import React from "react";
import { DateRangeLabel } from "stores/ComponentStores/DatePickerComponentStore";

interface iCalendarSideBar {
    handleSelectedDateOptionChange?: (inputVal: any) => void;
    dateIntervalOptions: DateRangeLabel[];
}

export default function CalendarSideBar(props: iCalendarSideBar) {
    const theme = useTheme();

    return (
        <Stack>
            {props.dateIntervalOptions.map((option, index) => {
                return (
                    <Grid
                        container
                        key={index}
                        id="date-option"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        sx={{
                            padding: "10px 14px",
                            textWrap: "nowrap",
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor:
                                    theme.palette.lightBlue.background,
                            },
                        }}
                        onClick={() => {
                            props.handleSelectedDateOptionChange?.(option);
                        }}
                    >
                        {" "}
                        {option}{" "}
                    </Grid>
                );
            })}
        </Stack>
    );
}
